import styled from "@emotion/styled";

const DrawerFooter = styled('div')`
	margin: 0 auto;
	color: #ffffff;
	padding: .5rem;
	font-size: 12px;
`;
export default DrawerFooter;